module.exports = __webpack_public_path__ + "img/mov.880f377e.png";